module.exports = __webpack_public_path__ + "img/user-name.794828b6.svg";